import { forwardRef } from "react";
import { classNames } from "zeta-dom-react";

export const GridContainer = forwardRef<HTMLDivElement, React.ComponentPropsWithRef<'div'>>((props, ref) => {
    return (<div {...props} ref={ref} className={classNames('eac-grid-item-container', props.className)}></div>);
});
